export default __webpack_public_path__ + "static/media/Jagged Cut.fc345018.jpg";